var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIsactive = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.375 0.375H2.625C1.3875 0.375 0.375 1.3875 0.375 2.625V18.375C0.375 19.6125 1.3875 20.625 2.625 20.625H18.375C19.6125 20.625 20.625 19.6125 20.625 18.375V2.625C20.625 1.3875 19.6125 0.375 18.375 0.375ZM9.04875 15.3263C8.94467 15.4305 8.82105 15.5133 8.68495 15.5697C8.54886 15.6262 8.40296 15.6552 8.25563 15.6552C8.10829 15.6552 7.96239 15.6262 7.8263 15.5697C7.6902 15.5133 7.56658 15.4305 7.4625 15.3263L3.42375 11.2875C3.3196 11.1833 3.23698 11.0597 3.18061 10.9236C3.12424 10.7875 3.09523 10.6417 3.09523 10.4944C3.09523 10.3471 3.12424 10.2012 3.18061 10.0651C3.23698 9.92905 3.3196 9.8054 3.42375 9.70125C3.5279 9.5971 3.65155 9.51448 3.78764 9.45811C3.92372 9.40174 4.06958 9.37273 4.21687 9.37273C4.36417 9.37273 4.51003 9.40174 4.64611 9.45811C4.7822 9.51448 4.90585 9.5971 5.01 9.70125L8.25 12.9413L15.99 5.20125C16.2003 4.9909 16.4856 4.87273 16.7831 4.87273C17.0806 4.87273 17.3659 4.9909 17.5763 5.20125C17.7866 5.4116 17.9048 5.6969 17.9048 5.99437C17.9048 6.29185 17.7866 6.57715 17.5763 6.7875L9.04875 15.3263Z",
    fill: "#037782"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIsactive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/isactive.9da353a7b23b7251aade1123f4ce832d.svg";